import React, { FC } from 'react';

import './VerifiedIcon.scss';
import classNames from 'classnames';

// eslint-disable-next-line max-len

type OwnProps = {
  isPremium?: boolean;
};

const VerifiedIcon: FC<OwnProps> = ({ isPremium }) => {
  return (
    <svg
      className={classNames('VerifiedIcon', { premium: isPremium })}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 18 18'
    >
      <circle cx='9' cy='9' r='5' fill='#fff' />
      <path
        fill='#0A49A5'
        fillRule='evenodd'
        d='M10.993 2.24c.451-.216 1.025.034 1.2.502.225.599.593 1.353 1.153 1.914.56.561 1.314.929 1.911 1.153.469.176.718.75.502 1.203-.29.609-.605 1.404-.605 1.988 0 .614.346 1.457.647 2.076a.867.867 0 0 1-.43 1.151c-.614.269-1.429.702-2.025 1.3-.542.542-.903 1.22-1.13 1.762-.19.457-.757.696-1.202.482-.611-.294-1.417-.616-2.008-.616-.61 0-1.45.344-2.067.645-.426.207-.982.005-1.19-.422-.27-.556-.691-1.28-1.263-1.852-.583-.583-1.322-1.01-1.882-1.28-.417-.201-.609-.728-.405-1.144.304-.621.66-1.48.66-2.102 0-.591-.322-1.397-.616-2.01-.213-.445.026-1.013.481-1.203.543-.227 1.22-.589 1.762-1.131.596-.597 1.029-1.413 1.297-2.027a.866.866 0 0 1 1.15-.43c.618.3 1.461.647 2.073.647.585 0 1.378-.315 1.987-.606Zm1.101 4.377a.494.494 0 0 0-.718 0l-3.454 3.608L6.6 8.848a.494.494 0 0 0-.719 0 .546.546 0 0 0 0 .75l1.72 1.792c.107.106.38.254.624 0l3.868-4.032a.536.536 0 0 0 0-.741Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default VerifiedIcon;
